<template>
    <div :class="$style.templateFilter">
        <h5 :class="$style.filterTitle">{{ props.typeName }}</h5>
        <div :class="$style.filterCategories">
            <pt-checkbox
                v-for="item in props.list"
                v-model="item.isChecked"
                class="pt-mb16"
                size="medium"
                :key="item.key"
            >
                {{ $t(item.name) }}
            </pt-checkbox>
        </div>
    </div>
</template>

<script lang="ts">
export default {
    name: 'TemplateFilter'
};
</script>

<script lang="ts" setup>
import type { TemplateFilterItem } from '@experience/static/config/experience.type';
// interface
interface Props {
    typeName: string;
    list: TemplateFilterItem[];
}
// props
const props = defineProps<Props>();
// emits

// state

// computed

// watch

// onMounted

// onUnmounted

// function
</script>

<style lang="scss" module>
@import '@style/import.scss';
.templateFilter {
    &:not(:nth-last-of-type(1)) {
        margin-bottom: 40px;
    }
    .filterTitle {
        font-size: 16px;
        color: $pt-black-900;
        font-weight: 500;
        margin-bottom: 12px;
    }
    .filterCategories {
        :global {
            .pt-checkbox {
                display: block;
            }
            .pt-checkbox__inner {
                width: 16px;
                height: 16px;
            }
            .pt-checkbox__input .pt-checkbox__inner::after {
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%) rotate(45deg) scaleY(1);
            }
        }
    }
}
</style>